export default __webpack_public_path__ + "static/media/secret_invasion_003.4dde6a88.jpg";